<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2 [langkey]="announceData.title"></h2>
    <div>
      <div class="announce_content"><span [langkey]="announceData.content"></span></div>
    </div>
    <div class="buttonscontainer">
      <div class="ya-button-container">
        <button mat-flat-button (click)="firstBtnClick()" data-testid="dialog-confirm-button">
          <span [langkey]="announceData.firstBtnLabel"></span>
        </button>
      </div>
      <div class="ya-button-container">
        <button mat-flat-button (click)="secondBtnClick()" data-testid="dialog-cancel-button">
          <span [langkey]="announceData.secondBtnLabel"></span>
        </button>
      </div>
      <div class="ya-button-container" *ngIf="announceData.thirdBtnLabel">
        <button mat-flat-button (click)="thirdBtnClick()">
          <span [langkey]="announceData.thirdBtnLabel"></span>
        </button>
      </div>
    </div>
  </div>
</div>